import React from "react";
import * as Styled from "./styles";
import { Link } from "react-router-dom";
import { phoneNumberFormatting } from "../../../middlewares";
import { useTranslation } from "react-i18next";

interface MemberPanelProps {
  id?: any;
  value?: string | undefined;
  link?: any;
  data?: any;
}

const MemberPanel = (props: MemberPanelProps) => {
  const { t } = useTranslation();
  const birthday = (birth: any) => {
    const today = new Date().getFullYear();
    const myBirth = new Date(birth).getFullYear();
    return today - myBirth;
  };

  return (
    <Styled.Panel>
      <Styled.EmployeePanel>
        <Link to={props.link}>
          <Styled.PanelTop>
            <Styled.PanelInfo>
              <Styled.PanelName>{props.data.name}</Styled.PanelName>
              <Styled.PanelDetail>
                {t("components.employee.age")}{" "}
                {birthday(props.data.dateOfBirth)} /{" "}
                {props.data.sex === 0
                  ? t("components.employee.male")
                  : t("components.employee.female")}{" "}
                / {phoneNumberFormatting(props.data.phoneNumber)}
              </Styled.PanelDetail>
            </Styled.PanelInfo>
          </Styled.PanelTop>
          <hr />
          <Styled.PanelBottom>
            <Styled.PanelBottomBox>
              <Styled.PanelBottomBoxLeft>
                {t("components.employee.job")}
              </Styled.PanelBottomBoxLeft>
              <div className="MemberPanel_bottom_box_right">
                {props.data.type === 0
                  ? t("components.employee.employeeTypeAdmin")
                  : t("components.employee.employeeTypeManager") &&
                    props.data.type === 2
                  ? t("components.employee.employeeTypeTeacher")
                  : t("components.employee.employeeTypeManager")}
              </div>
            </Styled.PanelBottomBox>
          </Styled.PanelBottom>
        </Link>
      </Styled.EmployeePanel>
    </Styled.Panel>
  );
};

export default MemberPanel;
